import { User } from 'src/features/users/users.types';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useDebugValue } from 'react';

export const useProfile = (): User | null => {
  const state = useSelector<RootState, RootState['auth']>(state => state.auth);

  useDebugValue(state.user);

  return state.user;
};
